import { BADGE_COLOR_VARIANTS } from '@bambi/component-library/src/components/Badge/Badge';

import { TripEventEnum } from 'src/common/external/bambi-api/bambiApi';
import colors from 'src/common/theme/colors';

export const eventTypeColorMap: Partial<Record<TripEventEnum, string>> = {
  status_en_route: colors.success[700],
  status_at_pickup: colors['daybreak-blue'][600],
  status_transporting: colors.warning[300],
  status_at_dropoff: colors.orange[500],
  completion: colors.success[500],
  cancellation: colors.error[500],
};

export const eventTypeColorMapToBadgeColorVariant: Partial<
  Record<TripEventEnum, string>
> = {
  status_en_route: BADGE_COLOR_VARIANTS.GREEN,
  status_at_pickup: BADGE_COLOR_VARIANTS.BLUE,
  status_transporting: BADGE_COLOR_VARIANTS.YELLOW,
  status_at_dropoff: BADGE_COLOR_VARIANTS.ORANGE,
};
